export const VALIDATION_ERROR_CODE = 100000

export interface ApiError {
  code: number,
  messages: Array<string>
}
